/* eslint-disable */
import {
  GET_CALL,
  POST_CALL,
  DELETE_CALL,
  PUT_CALL,
  LOCAL_BASE_URL
} from 'AccountsConstants/api_endpoints'
import { LOCAL_REDIRECT_LINK, WALLET_PWA_PATH, WALLET_DESKTOP_PATH } from 'AccountsConstants/routes'
import Axios from 'axios'
import {
  getQueryParams
} from 'AccountsUtils'
import { appendMobileViewURL } from './transform'
import { checkMobileDevice } from './validator'
import { getCookie, path } from './common'

export const readCookie = name => {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length)
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length)
    }
  }
  return null
}

export const createCookie = (name, value, days, domain) => {
  let expires
  let domainScope
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toGMTString()}`
  } else {
    expires = ''
  }

  if (domain) {
    domainScope = `; domain=${domain}`
  } else {
    domainScope = ''
  }
  document.cookie = `${name}=${value + expires + domainScope}; path=/`
}

export const eraseCookie = (name, domain) => {
  createCookie(name, '', -1, domain)
}

export const getUrlVars = () => {
  const vars = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    vars[key] = value
  })
  return vars
}

export const getUrlParam = parameter => {
  let urlParams = 'NA'
  if (window.location.href.indexOf(parameter) > -1) {
    urlParams = getUrlVars()[parameter]
  }
  return urlParams
}

export const apiPostHelper = async (
  URL,
  PAYLOAD,
  isPWA = true,
  contentType,
  requestHeaders
) => {
  try {
    const token = readCookie('tkn')
    let contentTypeText = 'application/json; charset=UTF-8, text/html'
    const params = new Proxy(new URLSearchParams(path(['location', 'search'], window)), {
      get: (searchParams, prop) => searchParams.get(prop)
    })
    const deviceType = params?.isAndroidApp === 'true'? "AndroidApp":params?.isIosApp === "true"? "iPhoneApp" :"PWA";
    let appAgent = 'PWA'
    if(deviceType === "AndroidApp") {
      appAgent = "AndroidApp"
    } else if (deviceType === "iPhoneApp") {
      appAgent = "iPhoneApp"
    } 
    if (contentType) {
      contentTypeText = contentType
    }
    let headers = isPWA
      ? {
          // 'X-CT-SOURCETYPE': 'mobile',
          'app-agent': appAgent,
          domain:
            process.env.webpackEnv === 'development'
              ? 'qa2.cleartrip.com'
              : 'www.cleartrip.com',
          new_tkn: token,
          'Content-Type': contentTypeText
        }
      : {
          new_tkn: token,
          'app-agent':'DESKTOP'
        }

    // if (requestHeaders) {
    //   headers['x-ct-caller-app'] = 'mobile'
    // } else {
    //   headers['X-CT-SOURCETYPE'] = 'pwa'
    // }

    headers = { ...headers, ...requestHeaders }

    let axiosUrl = URL
    if (window.location.origin.indexOf('0.0.0.0') > -1) {
      axiosUrl = `${LOCAL_BASE_URL}${URL}`
    }
    const responseData = await Axios.post(axiosUrl, PAYLOAD, {
      headers
    })
    return responseData
  } catch (e) {
    
      
    // setSentryError(e)
    return {
      error: e
    }
  }
}

export const apiPutHelper = async (
  URL,
  PAYLOAD,
  isPWA = true,
  contentType,
  requestHeaders
) => {
  try {
    const token = readCookie('tkn')
    let contentTypeText = 'application/json; charset=UTF-8, text/html'
    if (contentType) {
      contentTypeText = contentType
    }
    let headers = isPWA
      ? {
          // 'X-CT-SOURCETYPE': 'mobile',
          'app-agent': 'PWA',
          domain:
            process.env.webpackEnv === 'development'
              ? 'qa2.cleartrip.com'
              : 'www.cleartrip.com',
          new_tkn: token,
          'Content-Type': contentTypeText
        }
      : {
          new_tkn: token
        }

    // if (requestHeaders) {
    //   headers['x-ct-caller-app'] = 'mobile'
    // } else {
    //   headers['X-CT-SOURCETYPE'] = 'pwa'
    // }

    headers = { ...headers, ...requestHeaders }

    let axiosUrl = URL
    if (window.location.origin.indexOf('0.0.0.0') > -1) {
      axiosUrl = `${LOCAL_BASE_URL}${URL}`
    }
    const responseData = await Axios.put(axiosUrl, PAYLOAD, {
      headers
    })
    return responseData
  } catch (e) {
    // setSentryError(e)
    return {
      error: e
    }
  }
}

export const apiGetHelper = async (
  URL,
  isPWA = true,
  contentType,
  requestHeaders = {}
) => {
  try {
    const params = new Proxy(new URLSearchParams(path(['location', 'search'], window)), {
      get: (searchParams, prop) => searchParams.get(prop)
    })
    const deviceType = params?.isAndroidApp === 'true'? "AndroidApp":params?.isIosApp === "true"? "iPhoneApp" :"PWA";
    let appAgent = 'PWA'
    if(deviceType === "AndroidApp") {
      appAgent = "AndroidApp"
    } else if (deviceType === "iPhoneApp") {
      appAgent = "iPhoneApp"
    } 
    const token = readCookie('tkn')
    let contentTypeText = 'application/json; charset=UTF-8, text/html'
    if (contentType) {
      contentTypeText = contentType
    }
    let headers = isPWA
      ? {
          // 'X-CT-SOURCETYPE': 'mobile',
          'app-agent': appAgent,
          domain:
            process.env.webpackEnv === 'development'
              ? 'qa2.cleartrip.com'
              : 'www.cleartrip.com',
          new_tkn: token,
          'Content-Type': contentTypeText
        }
      : {
          new_tkn: token,
          'app-agent':'DESKTOP'
        }

    // if (requestHeaders) {
    //   headers['x-ct-caller-app'] = 'mobile'
    // } else {
    //   headers['X-CT-SOURCETYPE'] = 'pwa'
    // }

    headers = { ...headers, ...requestHeaders }

    let axiosUrl = URL
    if (window.location.origin.indexOf('0.0.0.0') > -1) {
      axiosUrl = `${LOCAL_BASE_URL}${URL}`
    }
    const responseData = await Axios.get(axiosUrl, {
      headers
    })
    return responseData
  } catch (e) {
    // setSentryError(e)
    return {
      error: e
    }
  }
}

export const httpAxios = (
  url,
  method = 'GET',
  data,
  isPWA = true,
  header_value = false,
  caller = false,
  extraHeaders = {}
) => {
  const token = readCookie('tkn')
  let instance
  const headers = isPWA
    ? {
        'X-CT-SOURCETYPE': 'mobile',
        'app-agent': 'PWA',
        'lan': getCookie('selectedLanguage') == 'ar'?'AR':'EN',
        'chnl': window.location.href.includes('flyin')?'Fly':'Ct',
        domain:
          process.env.webpackEnv === 'development'
            ? 'qa2.cleartrip.com'
            : 'www.cleartrip.com',
        new_tkn: token,
        ...extraHeaders
      }
    : {
      'lan': getCookie('selectedLanguage') == 'ar'?'AR':'EN',
      'chnl': window.location.href.includes('flyin')?'Fly':'Ct',
        new_tkn: token,
        ...extraHeaders
      }
  if (caller) {
    headers.caller = 'account'
  }
  const config = { timeout: 120000, headers }
  let axiosUrl = url
  if (window.location.origin.indexOf('0.0.0.0') > -1) {
    axiosUrl = `${LOCAL_BASE_URL}${url}`
  }
  if (method.toLowerCase() === GET_CALL) {
    instance = Axios.get(axiosUrl, { params: data, headers })
  } else if (method.toLowerCase() === POST_CALL) {
    instance = Axios.post(axiosUrl, data, config)
  } else if (method.toLowerCase() === DELETE_CALL) {
    instance = Axios.delete(axiosUrl, { params: data, headers })
  } else if (method.toLowerCase() === PUT_CALL) {
    instance = Axios.put(axiosUrl, data, config)
  }
  return instance
}
export const httpFetch = (url, method, data, isPWA = true) => {
  const token = readCookie('tkn')
  let instance
  const headers = isPWA
    ? {
        X_CT_SOURCETYPE: 'MOBILE',
        'app-agent': 'PWA',
        new_tkn: token
      }
    : {
        new_tkn: token
      }
  const config = { timeout: 120000, headers }
  let axiosUrl = url
  if (window.location.origin.indexOf('0.0.0.0') > -1) {
    axiosUrl = `${LOCAL_BASE_URL}${url}`
  }
  if (method.toLowerCase() === GET_CALL) {
    instance = Axios.get(axiosUrl, { params: data, headers })
  } else if (method.toLowerCase() === POST_CALL) {
    instance = Axios.post(axiosUrl, data, config)
  } else if (method.toLowerCase() === PUT_CALL) {
    instance = Axios.post(axiosUrl, data, config)
  }
  return instance
}
export const navigateToExternalLink = link => {
  let baseEnv = ''
  if (window.location.origin.indexOf('0.0.0.0') > -1) {
    baseEnv = LOCAL_REDIRECT_LINK
  }
  const params = getQueryParams()
  if (params && params.src === 'home' && params.isMobileApp === 'true') {
    window.location.href = appendMobileViewURL(`${baseEnv}${link}?src=home&isMobileApp=true`)
  } else {
    window.location.href = params && params.src === 'home' ? appendMobileViewURL(`${baseEnv}${link}?src=home`) : appendMobileViewURL(`${baseEnv}${link}?src=TDCT`)
  }
}

export const redirectMobileView = () => {
  let url = `${window.location.pathname}`
  if (checkMobileDevice()) {
    if (window.location.pathname.indexOf('/m/') === -1) {
      if (window.location.pathname.indexOf('/ar/') > -1) {
        url = window.location.pathname.replace('/ar/', '/ar/m/')
      } else if (window.location.pathname === WALLET_DESKTOP_PATH) {
        url = WALLET_PWA_PATH
      } else {
        url = `/m${window.location.pathname}`
      }
    }
  } else if (window.location.pathname.indexOf('/ar/') > -1) {
    url = window.location.pathname.replace('/ar/m/', '/ar/')
  } else {
    url = window.location.pathname.replace('/m/', '')
  }
  if (url !== window.location.pathname) {
    window.location.pathname = url
  }
}
